import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";
import { useTheme } from "../../context/ThemeContext";
import { Plus, Loader2 } from "lucide-react";
import { motion } from "framer-motion";

const AddNewVisit = ({ patientVisits, patientId, caseId, actionstatus }) => {
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, setSelectedVisit } = usePatient();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  const handleNewVisit = useCallback(async () => {
    try {
      setLoading(true);

      const updatedPatientData = {
        ...patientData,
        ACTION_STATUS: "ADD_NEW_VISIT",
      };

      const maxVisitId =
        patientVisits && patientVisits.length > 0
          ? Math.max(...patientVisits.map((v) => v.VISIT_ID))
          : 0;

      const newVisitId = maxVisitId + 1;

      setPatientData(updatedPatientData);
      setSelectedVisit(newVisitId);

      navigate(`/visits/${patientId}/${caseId}/${newVisitId}`);
    } catch (error) {
      console.error("Error creating new visit:", error);
    } finally {
      setLoading(false);
    }
  }, [patientVisits, patientData, navigate, patientId, caseId]);

  return (
    <div className="w-full">
      <motion.button
        whileHover={{ scale: 1.02, translateY: -2 }}
        whileTap={{ scale: 0.98 }}
        className="w-full py-4 px-6 rounded-2xl flex items-center justify-center gap-3 font-bold text-lg shadow-xl transition-all duration-300 border"
        style={{
          backgroundColor: theme.primary,
          color: "#ffffff",
          borderColor: "rgba(255,255,255,0.1)",
        }}
        onClick={handleNewVisit}
        disabled={loading}
      >
        {loading ? (
          <Loader2 size={24} className="animate-spin" />
        ) : (
          <Plus size={24} strokeWidth={2.5} />
        )}
        <span>{loading ? "Adding Visit..." : "Start New Visit"}</span>
      </motion.button>

      <p className="mt-4 text-xs text-center opacity-50 font-medium px-4 leading-relaxed" style={{ color: theme.text }}>
        Initiate a new medical visit for Case #{caseId}. All previous case data will be available for reference.
      </p>
    </div>
  );
};

export default AddNewVisit;
